const appConfig = {
  "name": "appstore-web",
  "version": "0.1.0",
  "stage": "test",
  "regions": [
    {
      "name": "us-east-1",
      "isPrimaryRegion": true,
      "deployThisBuild": true,
      "okta": {
        "issuer": "https://okta.mit.edu/oauth2/aus6shd5478WH30vd697",
        "clientId": "no_client_id",
        "redirectUri": "https://apps.atlas-apps-test.mit.edu",
        "scopes": []
      },
      "api": {
        "domain": "global.api-test.mit.edu",
        "paths": {}
      }
    }
  ]
};
export default appConfig;